// extracted by mini-css-extract-plugin
export var logo = "WordMark-module--logo--473eb";
export var root = "WordMark-module--root--2eecc";
export var title = "WordMark-module--title--e1ab8";